(function ($) {
  var $ = jQuery = $;

  let cc = {
    sections: []
  };

  $(document).on('click', '.image-grid__item', function () {
    let $div = $(this);
    let fullimg = $( this ).find( "img" ).attr( "data-full_size" );
    let caption = $( this ).find( "img" ).attr( "data-caption" );
    let link = $( this ).find( "img" ).attr( "data-product_link" );
    
    $('body').addClass('gallery-modal-open');

    createGalleryModal(fullimg, caption, link);

    return false;
  });

  $(document).on('click', '#gallery_modal .close', function () {
    $( '#gallery_modal' ).remove();
    $('body').removeClass('gallery-modal-open');
  });
  $(document).on('click', '#gallery_modal', function (e) {
    if (e.target.id === "gallery_modal"){
      $( '#gallery_modal' ).remove();
      $('body').removeClass('gallery-modal-open');
    }
   
  });
  $(document).on('keydown', function(event) {
       if (event.key == "Escape") {
          $( '#gallery_modal' ).remove();
          $('body').removeClass('gallery-modal-open');
       }
   });
  

  function createGalleryModal(fullimg, caption, link) {
    var captionBlock;
    var productLink;
    captionBlock = '';
    productLink = '';
    if (caption.length !== 0) {
      captionBlock = '<p class="modal-caption">' + caption + '</p>';
    }
    if (link.length !== 0) {
      productLink = '<a href="' + link + '" class="btn modal-btn">See Product</a>';
    }
    modal = $('<div id="gallery_modal" class="gallery-modal">'
            + '<span class="close">&times;</span>'
            + '<div class="modal-content" id="inner-modal">'
            + '<img src="' + fullimg + '">'
            + '<div class="caption-block">'
            + captionBlock
            + productLink
            + '</div>'
            + '</div>'
            + '</div>');
    $('body').append(modal);
  }

  
})(theme.jQuery);  